<template>
  <div class="position-relative">
    <b-form-input
      v-model="selected_value"
      @focus.native="is_close = false"
      @blur.native="handleBlur"
      autocomplete="off"
      maxlength="4"
      @input="error = null"
      :state="isInvalid()"
      :class="['inputdropdown-text cursor-pointer', { 'bg-disabled': !enabled }]"
      :disabled="!enabled"
      readonly>
    </b-form-input>
    <div
      id="options-container"
      class="bg-white position-absolute w-100" v-if="!is_close">
      <div v-for="(value, index) in timeOptions" :key="`value_${index}`"
        :class="['px-3 py-2 cursor-pointer', { 'bg-selected': value === selected_value }]"
        @click.self="setSelectedValue(value)">
        {{ value }}
      </div>
    </div>
    <b-form-invalid-feedback :force-show="!!error">{{ error }}</b-form-invalid-feedback>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "TimeInputDropdownComponent",
  props: ["enabled", "minimum", "maximum", "origin", "index", "selectedValue"],
  data() {
    return {
      selected_value: null,
      is_close: true,
      error: null,
      interval: 30
    }
  },
  computed: {
    timeOptions() {
      const getTime = (time, index) => {
        return this[time].split(':')[index];
      };
      const minimum = moment(new Date()).set('hour', getTime('minimum', 0)).set('minute', getTime('minimum', 1))._d;
      let maximum = moment(new Date()).set('hour', getTime('maximum', 0)).set('minute', getTime('maximum', 1)).add(1, 'minutes')._d;

      if (maximum < minimum) maximum = moment(maximum).add(1, 'days')._d; // handle if closing time is next day

      let startTime = moment(minimum, "HH:mm");
      let endTime = moment(maximum, "HH:mm");

      const timeOptions = [];
      while (startTime < endTime) {
        //Push times
        timeOptions.push(startTime.format("h:mm A"));
        //Add interval of 30 minutes
        startTime = startTime.add(this.interval, 'minutes');
      }

      return timeOptions;
    }
  },
  created() {
    this.selected_value = this.selectedValue
      ? moment(moment(this.selectedValue, "h:mm A")._d).format("h:mm A")
      : this.origin === 'minimum'
        ? this.timeOptions[0]
        : this.timeOptions[this.timeOptions.length - 1];
  },
  methods: {
    setSelectedValue(value) {
      this.selected_value = value;
      this.$emit("setValue", { origin: this.origin, value: value, opIndex: this.index });
      this.$root.$emit("changesDetected");
      this.$nextTick(() => {
        this.is_close = true;
      });
    },
    handleBlur() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.is_close = true;
        });
      }, 200);
    },
    isInvalid() {
      return this.error ? false : null;
    }
  },
  watch: {
    selectedValue(value) {
      this.selected_value = moment(moment(value, "h:mm A")._d).format("h:mm A");
    }
  }
}
</script>

<style lang="scss" scoped>
.inputdropdown-text {
  background: url('../../assets/images/caret-down.svg') no-repeat center right 10px;
  &.bg-disabled {
    background-color: #E9EBED;
  }
}
#options-container {
  z-index: 2;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  .bg-selected {
    background: rgba(255, 138, 0, 0.1);
  }
}
</style>
